export const urlifyName = (name) => {
    if (typeof name !== 'string') {
        console.error('Expected a string but received:', name);
        return '';
    }
    return name.toLowerCase().replaceAll(' ', '-');
}
